import type React from 'react';
import { Tooltip } from 'antd';
import startCase from 'lodash/startCase';
import { PROMO_STATUS_COLORS } from '../../config/calendarConstants';
import type { CalendarRow } from '../../types/calendar';

export const renderEventName = (text: string, record: CalendarRow): React.ReactNode => (
    <p className={`truncate text-sm ${record.children ? 'cursor-pointer font-semibold' : 'font-normal'}`}>{text}</p>
);

export const renderPromoName = (text: string, record: CalendarRow, isEditable = false): React.ReactNode => {
    const nameText = (
        <p className={`truncate text-sm font-normal ${isEditable ? 'text-purpleFont underline' : ''}`}>{text}</p>
    );

    return (
        <div className="flex flex-row items-center gap-x-2">
            <Tooltip title={startCase(record.promo_status ?? '')} showArrow={false}>
                <div
                    className="w-2 h-2 rounded-full"
                    style={{ backgroundColor: PROMO_STATUS_COLORS[(record.promo_status ?? '').toLowerCase()] }}
                />
            </Tooltip>
            {isEditable ? <Tooltip title="Click to edit" showArrow={false}>{nameText}</Tooltip> : nameText}
        </div>
    );
};

export const renderPlainText = (text: string): React.ReactNode => (
    <p className="truncate text-sm font-normal">{text}</p>
);

export const renderStatus = (text: string): React.ReactNode => (
    <p className="truncate text-sm font-normal">{startCase(text)}</p>
);

export const CALENDAR_CELL_RENDERERS: Record<string, (text: any, record: CalendarRow) => React.ReactNode> = {
    event_name: renderEventName,
    promo_name: renderPromoName,
    promo_id: renderPlainText,
    event_id: renderPlainText,
    promo_status: renderStatus,
};
